import React, { useEffect, useRef, useState } from 'react';
import { LogoLink } from '../components/logo/LogoLink';
import { Content } from '../components/content/Content';
import { Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DisplacementSphere from '../components/background/DisplacementSphere';
import { ThemeToggle } from '../components/theme/ThemeToggle';
import { Resume } from '../components/resume/Resume';
import { SocialIcons } from '../components/content/SocialIcons';
import { SpeedDials } from '../components/speedDial/SpeedDial';
import { SideNavbar } from '../components/nav/SideNavbar';
import { Works } from '../components/works/Works';
import { About } from '../components/about/About';
import { Contact } from '../components/contact/Contact';
import { Certificates } from '../components/certificates/Certificates';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
}));

export const Home = () => {
  const classes = useStyles();
  const [showContact, setShowContact] = useState(false);
  const contactRef = useRef(null);

  useEffect(() => {
    const handleToggleContact = () => {
      setShowContact(prev => {
        const newState = !prev;
        if (!prev) {
          setTimeout(() => {
            contactRef.current?.scrollIntoView({ behavior: 'smooth' });
          }, 100);
        }
        return newState;
      });
    };

    window.addEventListener('show-contact', handleToggleContact);

    // ✅ Emoji Rain cursor effect
    window.addEventListener('load', () => {
      if (window.cursoreffects && window.cursoreffects.emojiCursor) {
        new window.cursoreffects.emojiCursor({
          emoji: ['✨', '✨', '✨','✨', '✨', '✨'], // You can customize emojis here
          delay: 16,
        });
      }
    });

    return () => window.removeEventListener('show-contact', handleToggleContact);
  }, []);

  return (
    <div className={classes.root} id="home">
      <DisplacementSphere />
      <LogoLink />
      <Content />
      <ThemeToggle />
      <Hidden smDown>
        <SocialIcons />
      </Hidden>
      <Hidden mdUp>
        <SpeedDials />
      </Hidden>
      <Resume />
      <SideNavbar />
      <Works />
      <Certificates />
      <About />
      {showContact && (
        <div ref={contactRef}>
          <Contact />
        </div>
      )}
    </div>
  );
};
